import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=3a91ef0f&scoped=true&"
import script from "./PhotoGallery.vue?vue&type=script&lang=ts&"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=3a91ef0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91ef0f",
  null
  
)

export default component.exports